import React from "react";

export const AppBarMenuContext = React.createContext({});

export const useAppBarMenuContext = () => React.useContext(AppBarMenuContext);